import { render } from "./userBranchRelationshipDetails.vue?vue&type=template&id=62eff69e"
import script from "./userBranchRelationshipDetails.vue?vue&type=script&lang=js"
export * from "./userBranchRelationshipDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__